import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/solid/grip-vertical.svg'
import BaseIcon from '../../BaseIcon'

const GripVertical = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 320 512" />
}

GripVertical.propTypes = {
	className: PropTypes.string,
}

export default GripVertical
